import React from 'react';

import { useIntl } from 'react-intl';

import { Card, Grid, useTheme, Stack, IconButton, Typography } from '@mui/material';
import { CalendarMonth, Filter, Inventory, LocalShipping } from '@mui/icons-material';

const resumenIcons = {
    CalendarMonth,
    Filter,
    Inventory,
    LocalShipping
};

export default function SummaryCard({ data }: { data: Record<string, any> }) {
    // hooks
    const theme = useTheme();
    const intl = useIntl();

    return (
        <Card
            sx={{
                pb: 0,
                border: '1px solid',
                borderColor: theme.palette.mode === 'dark' ? 'transparent' : theme.palette.grey[100],
                '&:hover': {
                    border: `1px solid${theme.palette.primary.main}`
                }
                // backgroundColor: {
                //     xs: 'red',
                //     sm: 'orange',
                //     md: 'navy',
                //     lg: 'pink',
                //     xl: 'plum'
                // }
            }}
        >
            <Grid container sx={{ p: 0 }} spacing={0.5}>
                {summaryCard.map((item, index) => {
                    const Icon = item.icon;
                    const dataKey = item.dataKey;

                    let dataLabel = data[dataKey];

                    if (dataKey === 'executionDate' && dataLabel) {
                        dataLabel = intl.formatDate(dataLabel, {
                            dateStyle: 'long'
                        });
                    }

                    if (!isNaN(dataLabel)) {
                        dataLabel = intl.formatNumber(dataLabel);
                    }

                    return (
                        <Grid item xs={12} sm={6} key={`resume-card-${index}`}>
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-around"
                                sx={{
                                    py: 3,
                                    px: 2,
                                    background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50]
                                }}
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4} sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                        <IconButton
                                            size="large"
                                            sx={{
                                                p: {
                                                    xs: 2,
                                                    sm: 1,
                                                    lg: 2
                                                },
                                                cursor: 'initial',
                                                background:
                                                    theme.palette.mode === 'dark' ? theme.palette.background.default : 'primary.light',
                                                color: theme.palette.secondary.main,
                                                '&:hover': {
                                                    background:
                                                        theme.palette.mode === 'dark' ? theme.palette.background.default : 'primary.light'
                                                }
                                            }}
                                        >
                                            <Icon
                                                sx={{
                                                    fontSize: {
                                                        xs: 25,
                                                        lg: 30
                                                    }
                                                }}
                                            />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={8} sm={8} sx={{ justifyContent: 'flex-start', alignItems: 'center', display: 'flex' }}>
                                        <Stack>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    fontSize: {
                                                        xs: 15,
                                                        md: 14,
                                                        lg: 15
                                                    },
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis'
                                                }}
                                                align="left"
                                            >
                                                {dataLabel}
                                            </Typography>
                                            <Typography variant="subtitle2" sx={{ fontSize: 13 }} align="left">
                                                {intl.formatMessage({ id: item.labelId })}
                                            </Typography>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Stack>
                        </Grid>
                    );
                })}
            </Grid>
        </Card>
    );
}

const summaryCard = [
    {
        labelId: 'total-images',
        icon: resumenIcons.Filter,
        dataKey: 'totalImages'
    },
    {
        labelId: 'total-products',
        icon: resumenIcons.LocalShipping,
        dataKey: 'totalProducts'
    },
    {
        labelId: 'total-skus',
        icon: resumenIcons.Inventory,
        dataKey: 'totalSkus'
    },
    {
        labelId: 'last-update',
        icon: resumenIcons.CalendarMonth,
        dataKey: 'executionDate'
    }
];
